<ng-container *ngIf="pageTemplate$ | async as pageTemplate">
  <app-conditional-content
    [conditionalContent]="pageTemplate | fillUrls | localizeAbsUrls"
  ></app-conditional-content>
</ng-container>
